
import { summarizeGameState } from "@/utils/debugUtils";
import { supabase } from "@/integrations/supabase/client";

/**
 * Generates a summary of the current game state for debugging
 */
export const generateGameStateSummary = async (
  gameId: string,
  roundNumber: number,
  botIsThinking: boolean,
  botHasChosenWord: boolean,
  userHasSubmitted: boolean,
  processingComplete: boolean
) => {
  if (!gameId) return;
  
  try {
    await summarizeGameState(
      supabase,
      gameId,
      roundNumber,
      botIsThinking,
      botHasChosenWord,
      userHasSubmitted,
      processingComplete
    );
  } catch (error) {
    console.error("Error generating game state summary:", error);
  }
};

/**
 * Creates a state setter bundle for easier passing to utility functions
 */
export const createStateSetters = (
  setRounds: (rounds: any) => void,
  setUsedWords: (usedWords: any) => void,
  setCurrentWord: (word: string) => void,
  setIsRevealed: (isRevealed: boolean) => void,
  setBotHasChosenWord: (hasChosen: boolean) => void,
  setBotIsThinking: (isThinking: boolean) => void,
  setShouldAutoFocus: (shouldAutoFocus: boolean) => void,
  setGameOver: (gameOver: boolean) => void,
  setConvergenceRound: (round: number | null) => void,
  setGameStatus: (status: string) => void,
  setUserHasSubmitted: (hasSubmitted: boolean) => void,
  setProcessingComplete: (complete: boolean) => void
) => {
  return {
    setRounds,
    setUsedWords,
    setCurrentWord,
    setIsRevealed,
    setBotHasChosenWord,
    setBotIsThinking,
    setShouldAutoFocus,
    setGameOver,
    setConvergenceRound,
    setGameStatus,
    setUserHasSubmitted,
    setProcessingComplete
  };
};
